import { SQLGeneratedProcess } from "@avenueops/shared-types";
import * as HoverCard from "@radix-ui/react-hover-card";
import { SizeIcon } from "@radix-ui/react-icons";
import MarkdownMessageText from "components/generic-building-blocks/MarkdownMessageText";
import Link from "next/link";
import { pagesPath } from "utils/$path";

interface Props {
  row: SQLGeneratedProcess;
}

export default function Title({ row }: Props): JSX.Element {
  return (
    <HoverCard.Root>
      <HoverCard.Trigger asChild>
        <div className="relative group">
          <div className="truncate text-ellipsis">{row.title}</div>
          <div className="invisible group-hover:visible absolute bottom-0 right-0 bg-white rounded-lg shadow px-2 py-1">
            <Link href={pagesPath.signals._id(row.id).$url()} onClick={(e) => e.stopPropagation()} className="items-center align-center">
              <SizeIcon className="text-gray-500 w-5 h-5 " />
            </Link>
          </div>
        </div>
      </HoverCard.Trigger>
      <HoverCard.Portal>
        <HoverCard.Content
          className="relative z-15 shadow-lg max-w-md  min-w-[300px]  overflow-hidden rounded-lg p-3 bg-white"
          sideOffset={5}
          avoidCollisions={true}
          align={"start"}
        >
          <div className="flex flex-col">
            {row.title ? <div className="border-b p-1 font-bold text-sm">{row.title}</div> : undefined}
            <div className="p-1 text-sm">
              <div className="text-gray-500 py-2">Message </div>
              <MarkdownMessageText message={row.message} />
            </div>
          </div>
        </HoverCard.Content>
      </HoverCard.Portal>
    </HoverCard.Root>
  );
}
